<template>
    <div class="list-group border-radius-2 no-border">
        <SessionAdvancedSearch 
            v-model="filters"
            class="list-group-item sticky-top"
            @input="refresh"
            :lockUser="true"
        />
        <ScrollPaginator
            :data="sessions"
            :submitting="submitting"
            :filters="filters"
            @toPage="toPage"
            :maxPages="5"
            :scrollElementId="scrollElementId"
        >
            <template v-slot:item="{ item: session }">
                <SessionListItem 
                    :session="session"
                    @click="toggleSession(session)"
                    :class="{ 'bg-light': value.findIndex(el => el.id === session.id) > -1}"
                />
            </template>
            <template v-slot:skeletonLoader>
                <SkeletonRow />
            </template>
        </ScrollPaginator>
    </div>
</template>

<script>
import ScrollPaginator from "../../components/Table/ScrollPaginator.vue";
import SessionAdvancedSearch from "./SessionAdvancedSearch.vue";
import SessionListItem from "./SessionListItem.vue";
import SkeletonRow from "src/components/Table/SkeletonRow.vue";

export default {
    components: {
        ScrollPaginator,
        SessionAdvancedSearch,
        SessionListItem,
        SkeletonRow,
    },
    props: {
        value: {
            type: Array,
            default: () => [],
        },
        scrollElementId: {
            type: String,
            default: 'main',
        }
    },
    mounted() {
        const promise = this.fetchSessions()
        if (promise) promise.then(() => { this.loading = false })
    },
    data() {
        return {
            sessions: [],
            loading: true,
            submitting: false,
            filters: {
                page: 1,
                page_size: 10,
                total: 0,
                search: '',
                isLocked: null,
				reflection: null,
				studentId: null,
				student_displayname: "",
				teacherId: null,
				teacher_displayname: "",
				programme: null,
				year: null,
				group: null,
				specialtyId: null,
				typeId: null,
				clinicId: null,
            },
        }
    },
    methods: {
        fetchSessions() {
            if (this.submitting) return
            this.submitting = true

            return this.$cfetch(`${this.$settings.APIBaseURL}/treatmentsessions/list`, {
                method: 'post',
                data: {
                    ...this.filters,
                    pg: this.filters.page,
                    q: this.filters.search,
                    programme: this.filters.programme ? this.filters.programme.Id : undefined,
                },
            }).then(res => {
                if (res.status !== 'SUCCESS') throw new Error('Unexpected error fetching competency test sessions')

                this.sessions = res.treatmentsessions
                this.filters.page = Number(res.pagination.page)
                this.filters.total = Number(res.pagination.total)
            }).catch(err => {
                console.error(err)
                this.$log.error.call(this, err)
                this.$store.commit('openDialog', {
                    title: this.$t('something-went-wrong'),
                    content: this.$t('error-fetching-treatment-sessions'),
                })
            }).finally(() => {
                this.submitting = false
            })
        },
        toggleSession(session) {
            const index = this.value.findIndex(el => el.id === session.id)
            if (index > -1) this.value.splice(index, 1)
            else this.value.push(session)
            
            this.$emit('input', this.value)
        },
        toPage(pageNo) {
            this.filters.page = pageNo
            this.fetchSessions()
        },
        refresh(filters) {
            this.filters = {
                ...this.filters,
                ...filters,
                page: 1,
            }
            this.fetchSessions()
        }
    }
}
</script>